/**
 * Archivo: assets/recargo-detector.js
 * Propósito: Detectar y guardar estado de recargo en localStorage
 */

(function() {
  'use strict';
  
  const STORAGE_KEY = 'shopify_recargo_equivalencia';
  const STORAGE_EXPIRY = 'shopify_recargo_expiry';
  const EXPIRY_DAYS = 7; // Caducidad de la información
  
  /**
   * Verificar que los datos del customer estén disponibles
   */
  if (typeof window.ShopifyCustomer === 'undefined') {
    console.error('recargo-customer-data.liquid no está cargado');
    return;
  }
  
  const customerData = window.ShopifyCustomer;
  const isLoggedIn = customerData.isLoggedIn;
  
  function checkAndStoreRecargo() {
    if (isLoggedIn) {
      // Cliente logueado: verificar tag y guardar en localStorage
      const hasTags = customerData.tags && customerData.tags.length > 0;
      const needsRecargo = hasTags && customerData.tags.includes('recargo-equivalencia');
      
      if (needsRecargo) {
        const expiryDate = Date.now() + (EXPIRY_DAYS * 24 * 60 * 60 * 1000);
        localStorage.setItem(STORAGE_KEY, '1');
        localStorage.setItem(STORAGE_EXPIRY, expiryDate.toString());
        console.log('✓ Cliente con recargo de equivalencia detectado');
        return true;
      } else {
        // Cliente logueado pero SIN recargo
        localStorage.removeItem(STORAGE_KEY);
        localStorage.removeItem(STORAGE_EXPIRY);
        console.log('✓ Cliente sin recargo de equivalencia');
        return false;
      }
    } else {
      // NO logueado: verificar localStorage
      const stored = localStorage.getItem(STORAGE_KEY);
      const expiry = localStorage.getItem(STORAGE_EXPIRY);
      
      if (stored === '1' && expiry && Date.now() < parseInt(expiry)) {
        console.log('✓ Recargo válido desde localStorage');
        return true; // Tiene recargo guardado y válido
      }
      
      // Expirado o no existe
      localStorage.removeItem(STORAGE_KEY);
      localStorage.removeItem(STORAGE_EXPIRY);
      return false;
    }
  }
  
  // Ejecutar comprobación
  const needsRecargo = checkAndStoreRecargo();
  
  // Exponer globalmente para otros scripts
  window.ShopifyRecargo = {
    needsRecargo: needsRecargo,
    isLoggedIn: isLoggedIn,
    customerId: customerData.id
  };
  
  console.log('ShopifyRecargo inicializado:', window.ShopifyRecargo);
})();